'use client'
import React, { useContext, useEffect, useMemo } from 'react';

import { generalOperations } from '@/api/general';
import usePromise from '@/hooks/usePromise';


import { IGlobalContext } from './entities';
import usePersistentState from '@/hooks/usePersistentState';
import { useRouter } from 'next/navigation';

const initialValue = {
    settings: {
        fields_suffix: {},
        group_manual_sort_fields: [],
        group_sort_by_fields_values: {},
        storage_key: '',
        field_history_methodology: {}
    },
    pdfLayout: false,
    intakeDetailView: false
};

const GlobalContext = React.createContext<IGlobalContext>(initialValue)

const GlobalProvider = ({ children, pdfLayout, intakeDetailView }: { children: React.ReactNode, pdfLayout?: boolean, intakeDetailView?: boolean }) => {

    const [settings, setSettings] = usePersistentState<IGlobalContext['settings']>('@global.settings', initialValue.settings);
    const router = useRouter();
    const { perform } = usePromise(generalOperations.getConfigs)

    useEffect(() => {
        perform('ui_settings').then((res) => {
            if (!res.storage_key) {
                console.error('Fatal Error: storage_key not found on ui_settings response object')
                return;
            }
            if (!localStorage.getItem('@global.storage_key')) {
                if (res.storage_key) localStorage.setItem('@global.storage_key', res.storage_key)
            } else if (res.storage_key !== localStorage.getItem('@global.storage_key')) {
                console.warn('Global storage_key changed - Cleaning localStorage');

                Object.keys(localStorage).forEach(key => {
                    localStorage.removeItem(key);
                });

                router.push('/')
            }

            setSettings(res)

        });
    }, [])

    const _pdfLayout = useMemo(() => {
        if(pdfLayout != undefined) return pdfLayout;
        if (typeof window == 'undefined') return false;
        return new URLSearchParams(window.location.search).get('pdf_layout') === 'true';
    }, [])

    const _intakeDetailView = useMemo(() => {
        if(intakeDetailView != undefined) return intakeDetailView;
        if (typeof window == 'undefined') return false;
        return new URLSearchParams(window.location.search).get('intake_detail_view') === 'true';
    }, [])

    return (
        <GlobalContext.Provider value={{
            settings: { ...initialValue.settings, ...settings },
            pdfLayout: _pdfLayout,
            intakeDetailView: _intakeDetailView
        }}>
            {children}
        </GlobalContext.Provider>
    );
}


const useGlobal = () => useContext(GlobalContext);

export { GlobalProvider, useGlobal }